import { Typography, styled } from '@mui/material';
import type { ContextItemFileType } from 'src/@types/ai';
import Iconify from 'src/components/iconify';
import { AIContextIcon } from 'src/modules/ai-conversation/components/AIInput/AIActionButtons/AIContextIcon';
import { useAIContextActionsUtils } from 'src/modules/ai-conversation/components/AIInput/AIActionButtons/useAIContextActionsUtils';
import { ToggleButton } from 'src/modules/ai-conversation/components/AIInput/styles';
import type { AIInputStateControl } from 'src/modules/ai-conversation/components/AIInput/useAIInputState';

export const AiContextFiles = ({
  control,
}: {
  control: AIInputStateControl;
}) => {
  const { files, toggleContextFiles } = control((s) => ({
    files: s.contextFiles,
    toggleContextFiles: s.toggleContextFiles,
  }));

  const { getLabel } = useAIContextActionsUtils();

  if (!files.length) return null;

  return (
    <StyledContextContainer>
      {!!files.length &&
        files.map((item, index) => (
          <ToggleButton key={index} className="active context-icon-button">
            <div className="context-icon">
              <AIContextIcon item={item} />
            </div>
            <Iconify
              className="remove-icon"
              icon="tabler:x"
              color="error"
              onClick={(e) => {
                e.stopPropagation();
                toggleContextFiles(
                  item.type,
                  item[item.type]! as ContextItemFileType,
                );
              }}
            />
            <Typography
              variant="caption"
              sx={{
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {getLabel(item)}
            </Typography>
          </ToggleButton>
        ))}
    </StyledContextContainer>
  );
};

const StyledContextContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  overflowX: 'auto',
  flexGrow: 1,
  scrollbarWidth: 'thin',
}));
